import { useCallback } from 'react';
import { EmptyView, Flex, IconEmptyShak, PrimaryButton } from '@banhala/ui-kit';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useConfigs } from 'shared/src/queries';
import { useLogClickTodayDelivery } from '../hooks/useLogClickTodayDelivery';

/**
 * 배송 필터 ON 상태에서 결과 0건일 때 노출되는 빈 화면.
 * iOS `RelatedDeliveryEmptyCell`과 동일 구성 (오늘출발 아이콘 + 안내 + CTA).
 */
export const DeliveryFilterEmpty = () => {
  const { data: configs } = useConfigs();
  const { openDeeplink } = useOpenDeeplink();
  const logClickTodayDelivery = useLogClickTodayDelivery();

  const handlePress = useCallback(() => {
    logClickTodayDelivery();
    openDeeplink(configs.today_delivery.department_deeplink);
  }, [configs, logClickTodayDelivery, openDeeplink]);

  return (
    <Flex.Center flex={1} padding={{ vertical: 80 }}>
      <EmptyView
        title={'오늘출발 상품이 없어요'}
        icon={<IconEmptyShak />}
        button={
          <PrimaryButton onPress={handlePress}>오늘출발 보러가기</PrimaryButton>
        }
      />
    </Flex.Center>
  );
};